<template>
    <TransitionRoot as="template" :show="open">
        <Dialog class="relative" style="z-index: 1000" @close="closeBackdrop">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500/75 transition-opacity backdrop-blur" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel
                            class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg pt-12">

                            <button @click="closeButton"
                                :class="[closeable ? 'opacity-100' : 'opacity-0', 'absolute top-3 right-3 transition-opacity focus-visible:outline-none']">
                                <XMarkIcon class="size-5 text-gray-900 " />
                            </button>

                            <slot></slot>

                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { CheckIcon, XMarkIcon } from '@heroicons/vue/24/outline'


export default {

    props: {
        open: {
            type: Boolean,
            default: false
        },
        closeable: {
            type: Boolean,
            default: true
        }
    },

    components: {
        Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot,
        CheckIcon, XMarkIcon
    },

    data() {
        return {

        }
    },

    created: function () {

    },

    emits: ["close"],

    methods: {
        closeBackdrop() {
            console.log('closeBackdrop', this.closeable)
            if (this.closeable) {
                this.$emit('close')
            }
        },
        closeButton() {
            if (this.closeable) {
                this.$emit('close')
            }
        }
    },

    watch: {

    },

}

</script>
